import { apiFetch } from '../../../../utils/api';

// Export requests use the applied filters and backend-local dates, independent of visible report state.
export async function fetchReportExportData(routes, filters, { startDate, endDate, signal }) {
  const query = new URLSearchParams(Object.entries({ ...filters, startDate, endDate })
    .filter(([key, value]) => key !== 'allowLargeReport' && value != null && value !== '')).toString();
  const entries = await Promise.all(Object.entries(routes).map(async ([key, route]) => {
    const response = await apiFetch(`/updates-reports/${route}?${query}`, { signal });
    const raw = await response.text();
    let data;
    try { data = JSON.parse(raw); } catch { throw new Error('The reports server returned an invalid response. Please try again.'); }
    if (!response.ok) throw new Error(data?.error || `Unable to export: HTTP ${response.status}. Try a smaller range.`);
    if (!Array.isArray(data)) throw new Error('Unexpected report data. Export was not generated.');
    return [key, data];
  }));
  // Do not return partial reports when a required endpoint fails.
  return Object.fromEntries(entries);
}
